module.exports = __webpack_public_path__ + "img/988.2567ab17.png";